import React from 'react';
import keydown from 'react-keydown';

class InactiveBg extends React.PureComponent {
  componentDidMount() {
    document.body.classList.add('c-body--no-scroll');
  }

  componentWillUnmount() {
    this._unmounted = true;
    document.body.classList.remove('c-body--no-scroll');
  }

  componentWillReceiveProps({ keydown, onClose }) {
    if (keydown.event && onClose) {
      onClose(keydown.event);
    }
  }

  onClick = (e) => {
    if (this._unmounted) return;

    if (e.target.closest('.c-inactive-bg__stop')) return;

    const { onClose } = this.props;

    if (onClose) {
      onClose(e);
    }
  };

  render() {
    return (
      <section className="c-inactive-bg" onClick={this.onClick}>{this.props.children}</section>
    );
  }
}

export default keydown('esc')(InactiveBg);



// WEBPACK FOOTER //
// ./app/Assets/js/features/components/InactiveBg.js